import { makeStyles } from "@material-ui/core/styles";
import Navbar from "components/Navbars/Navbar.js";
import { get } from "lodash";
import React, { useState } from "react";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { dashboardRoutes } from "routes.js";
import backgroundImg from "../../assets/images/background/home.png";
import { getUserStoredCountry } from "../../v2_actions/auth_country";
import { ContextMenuSidebar } from "./ContextMenuSideBar";
import { GallerySideBar } from "./GallerySideBar";
import { TopMenuBar } from "./TopMenuBar";

const GALLERY_DRAWER_WIDTH = 230;

const useStyles = makeStyles({
  root: {
    height: "100vh",
    overflow: "hidden",
    background: "#ededed",
  },
  contentWrapper: {
    height: '89vh',
    display: "flex",
    overflow: 'hidden',
    marginBottom: "0px",
    marginRight: "10px",
    // width: `calc(100vw - ${GALLERY_DRAWER_WIDTH}px)`,
  },
  contentWrapperNoSidebar: {
    display: "flex",
    marginBottom: "0px",
    width: "100%",
    maxHeight: "89vh",
    overflowY: "auto",
    background: "#ffffff",
  },
  contentWrapperNoSidebarExpandedAcrossScreen: {
    width: "140%",
    height: "90vh",
    display: "flex",
    overflow: "scroll",
    marginBottom: "50px",
    border: 'solid 1px #000'
  },
  contentWrapperWithImage: {
    backgroundImage: `url(${backgroundImg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    width: `calc(100vw - ${GALLERY_DRAWER_WIDTH}px)`,
    height: "100%",
  },
  contentWrapperWithImageNoSidebar: {
    backgroundImage: `url(${backgroundImg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    width: "100vw",
    height: "100%",
  },
  childrenWrapper: {
    width: "100%",
    display: "flex",
  },
  topMenuBarContainer: {
    width: `calc(100vw)`,
    backgroundColor: "#ededed",
  },
  rightSideBar: {
    background: "white",
    paddingBottom: "25px",
    border: "1px solid #000",
    boxShadow: "1px 3px 2px 2px #000",
    boxShadow: "0px 5px 5px",
    marginRight: "20px",
    maxHeight: '89vh',
    overflowX: "hidden",
    overflowY: "scroll",
  },
  content: {},
  drawer: {
    width: GALLERY_DRAWER_WIDTH,
    flexShrink: 0,
  },
  drawerPaper: {
    width: GALLERY_DRAWER_WIDTH,
  },
  contextMenuSidebar: {
    marginTop: "-60px",
  },
});

export const PageLayout = ({
  title,
  gallery,
  withBackgroundImage,
  withRightSidebar,
  expandWidthAcrossScreen,
  hideViewSideBarForPhotoArt,
  hideGalleryDropdown,
  ...props
}) => {
  const classes = useStyles();
  const history = useHistory();
  const color = "blue";
  const country = getUserStoredCountry();
  const drawerWidth = useSelector((state) => state.gallery.drawWidth);
  const showContextMenu = useSelector((state) => state.user.showMenu);
  const [mobileOpen, setMobileOpen] = useState(false);

  const showSideBar = withRightSidebar != false;

  let children_wrapper_class = classes.contentWrapper;
  if (withBackgroundImage) {
    if (showSideBar) {
      children_wrapper_class = classes.contentWrapperWithImage;
    } else {
      children_wrapper_class = classes.contentWrapperWithImageNoSidebar;
    }
  } else {
    if (showSideBar) {
      children_wrapper_class = classes.contentWrapper;
    } else if (expandWidthAcrossScreen) {
      children_wrapper_class = classes.contentWrapperNoSidebarExpandedAcrossScreen;
    } else {
    children_wrapper_class = classes.contentWrapperNoSidebar;
    }
  }


  return (
    <div className={classes.root}>
      <div className={classes.topMenuBarContainer}>
        <TopMenuBar gallery={gallery} title={hideGalleryDropdown ? null : title} />
      </div>
      <Grid container spacing={1}>
        <NotificationContainer />
        <Grid item xs={2} className={classes.contextMenuSidebar}>
          <ContextMenuSidebar
            key="sidebar-photographer"
            routes={dashboardRoutes}
            color={color}
            theme={{ direction: "rtl" }}
            {...props}
          />
        </Grid>
        <Grid item xs={showSideBar ? 6 : (hideGalleryDropdown ? 10 : 6)} xl={showSideBar ? 7 : (hideGalleryDropdown ? 10 : 7)}>
          <div className={children_wrapper_class}>{props.children}</div>
        </Grid>
        <Grid item xs={showSideBar ? 4 : (hideGalleryDropdown ? false : 4)} xl={showSideBar ? 3 : (hideGalleryDropdown ? false : 3)}>
          {showSideBar && (
            <div id='rightSideBar' className={classes.rightSideBar}>
             <GallerySideBar
                country={country}
                hideViewSideBarForPhotoArt={ hideViewSideBarForPhotoArt }
                gallery_id={get(gallery, "id")}
             />
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};
